const cards = [
  {
    title: '顶流男星深夜密会神秘女子，酒店共度8小时证据确凿',
    excerpt: '据知情人士透露，该男星与一名圈外女性在某五星级酒店密会，两人前后进入酒店间隔仅5分钟，直到次日清晨才先后离开。',
    tag: '独家爆料',
    time: '2小时前',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20night%20scene%20with%20dramatic%20warm%20lighting%2C%20empty%20lobby%20with%20modern%20architecture%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20golden%20accents%2C%20no%20people%2C%20clean%20geometric%20lines%2C%20corporate%20luxury%20aesthetic&width=800&height=600&seq=card-01-chigua&orientation=landscape'
  },
  {
    title: '知名网红直播间口无遮拦惹祸，三大品牌连夜发解约函',
    excerpt: '该网红在直播中发表不当言论后，合作品牌火速切割。据不完全统计，已有多家品牌宣布终止合作，预估损失超千万。',
    tag: '热门追踪',
    time: '4小时前',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20setup%20with%20empty%20chair%20and%20professional%20equipment%2C%20moody%20lighting%2C%20dark%20background%2C%20warm%20red%20accent%20lights%2C%20editorial%20style%2C%20minimal%20composition%2C%20professional%20broadcast%20aesthetic&width=800&height=600&seq=card-02-chigua&orientation=landscape'
  },
  {
    title: '综艺节目导师当场翻脸，录制被迫中断三小时',
    excerpt: '某热门选秀综艺录制现场，两位导师因选手评分产生严重分歧，当场发生激烈争吵。节目组紧急协调后才恢复录制。',
    tag: '独家内幕',
    time: '6小时前',
    img: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20dramatic%20stage%20lighting%20and%20empty%20chairs%2C%20warm%20spotlights%2C%20theater%20atmosphere%2C%20red%20curtain%20background%2C%20editorial%20style%2C%20professional%20broadcast%20environment%2C%20cinematic%20lighting&width=800&height=600&seq=card-03-chigua&orientation=landscape'
  },
  {
    title: '女星红毯造型翻车，礼服意外滑落引发现场混乱',
    excerpt: '某知名女星出席时尚盛典时，所穿高定礼服疑似设计缺陷，在媒体区拍照时发生意外。现场数十家媒体争相拍摄。',
    tag: '热门吃瓜',
    time: '9小时前',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20with%20golden%20stanchions%20and%20dramatic%20lighting%2C%20empty%20carpet%20path%2C%20luxurious%20venue%20backdrop%2C%20paparazzi%20flash%20effect%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20glamorous%20atmosphere&width=800&height=600&seq=card-04-chigua&orientation=landscape'
  },
  {
    title: '选秀节目票数造假实锤，内部聊天记录曝光',
    excerpt: '一份疑似选秀节目工作人员的内部聊天记录在网络疯传，揭露了票数操纵的详细流程。节目组发布声明否认，但网友质疑声不断。',
    tag: '深度爆料',
    time: '12小时前',
    img: 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20computer%20screens%20showing%20data%20charts%2C%20warm%20ambient%20lighting%2C%20empty%20workspace%2C%20professional%20environment%2C%20editorial%20style%2C%20geometric%20composition%2C%20minimal%20clean%20aesthetic&width=800&height=600&seq=card-05-chigua&orientation=landscape'
  },
  {
    title: '明星夫妻被曝分居半年，双方工作室均未回应',
    excerpt: '据圈内人士透露，这对曾被视为模范夫妻的明星夫妇已分居超过半年。记者联系双方工作室，均未得到正面回应，引发外界诸多猜测。',
    tag: '最新爆料',
    time: '15小时前',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20apartment%20interior%20with%20split%20composition%2C%20warm%20ambient%20lighting%2C%20empty%20living%20space%2C%20minimal%20decor%2C%20editorial%20style%2C%20clean%20geometric%20lines%2C%20contemporary%20design%20aesthetic&width=800&height=600&seq=card-06-chigua&orientation=landscape'
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">精品爆料</h2>
        <p className="text-sm text-foreground-500 mb-8">精选网红吃瓜网站最新深度爆料，每一条都是精品</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <article key={idx} className="rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group flex flex-col">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-primary-500 text-background-50">{card.tag}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{card.excerpt}</p>
                <div className="flex items-center gap-1 mt-3 pt-3 border-t border-background-200/60">
                  <i className="ri-time-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-400">{card.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}